import { render } from "./PrintStudio.vue?vue&type=template&id=cbffe074"
import script from "./PrintStudio.vue?vue&type=script&lang=js"
export * from "./PrintStudio.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__